import { useEffect, useRef, useState } from "react";
import InputB from "../../../components/InputB/InputB";
import ItemCustomerDTO from "../../DTO/ItemCustomerDTO";
import { Plus } from "react-feather";
import { Status } from "../day/dayView";
import Spinner from "../../../components/Spinner/Spinner";
import Customer from "./Customer";
import { MItem } from "../Menu";
import PlaningToolRoot from "../PlaningToolRoot";
import { InfinitScroll } from "../../../services/InfinitScroll";
import { OptionArray, OptionArrayHasValue } from "../../../services/OptionArrayParser";
import { CustomersDTO } from "../../DTO/CustomersDTO";
import { sessionDataSaver } from "../../../services/SessionDataSaver";
import { Help } from "../Help";
import { Alert, Button, Tab, Tabs } from "@mui/material";
import UserCustomerMatrix from "./UserCustomerMatrix";

const customerListTabs = [
  {
    name: 'Alle Kunden',
    key: 'all',
  },
  {
    name: 'Zuständigkeiten',
    key: 'fkts',
  },
]

export default function CustomerList(props: {
  selected?: number,
  onSelect?: (id: number, customer: ItemCustomerDTO) => void,
  onTrash?: (id: number) => void,
  onRemove?: (id: number) => void,
  className?: string,
  personId?: number,
  standalone?: boolean,
  noSearch?: boolean,
  rerenderTrigger?: number,
  headline?: string,
  options?: OptionArray,
}) {
  const SLPlaceholder = props.standalone ? 'Standalone' : 'Local'
  const rememberNeedles = !!props.standalone
  const searchNeedlePlaceholder = `${SLPlaceholder}-customerNeedle`
  const currentPagePlaceholder = `${SLPlaceholder}-currentPage`
  const currentScrollPositionPlaceholder = `${SLPlaceholder}-currentScrollPosition`
  const oldPage = sessionDataSaver.get(currentPagePlaceholder, rememberNeedles)
  const [Needle, setNeedle] = useState(sessionDataSaver.get(searchNeedlePlaceholder, rememberNeedles))
  const [status, setStatus] = useState(Status.loading)
  const [Items] = useState(new CustomersDTO({
    getUrl: 'spt/customer/list',
    trashUrl: 'spt/customer/delete',
    personId: props.personId || -1,
    needle: Needle,
  }))
  const [tabKey, setTabKey] = useState('all')
  const [infinitScroll] = useState(new InfinitScroll({
    ref: useRef(null),
    cb: async () => {
      // What to do, if we are at the end of the list?
      const newPage = infinitScroll.incrementAndLock()
      console.log('we arrived at the end of the list! new page', newPage)
      if (newPage === -1) { return }
      setStatus(Status.loadMore)
      sessionDataSaver.set(currentPagePlaceholder, `${newPage}`)
      const newElementCount = await Items.getFromServer(newPage)
      console.log('we arrived newElementCount', newElementCount)
      if (newElementCount) {
        infinitScroll.unlock()
      }
      setStatus(Status.standard)
      // Now load new content - then set Status to "standard" and unlock
      // If nothing is loaded - lock permanently
    },
    saveScrollPositionCb: (scrollPosition: number) => {
      sessionDataSaver.set(currentScrollPositionPlaceholder, `${scrollPosition}`)
    },
    page: parseInt(oldPage, 10) || 0,
  }))
  const className = `STCustomerList flex flex-column ${props.className || ''}`
  function setGlobNeedle(n: string) {
    sessionDataSaver.set(searchNeedlePlaceholder, n)
    setNeedle(n)
  }
  useEffect(() => {
    setStatus(Status.loading)
    const oldScrollPosition = parseInt(sessionDataSaver.get(currentScrollPositionPlaceholder, rememberNeedles)) || 0
    Items.getFromServer(parseInt(`-${oldPage}`) || 0).then(() => {
      setStatus(Status.standard)
      infinitScroll.scrollToPosition(oldScrollPosition)
    })
  }, [props.rerenderTrigger])
  return <PlaningToolRoot standalone={props.standalone} menuItem={MItem.customers} mainContentClass={className}>
    {
      (props.standalone || props.headline) ?
      <div className='contentHeader'>
        {
          props.headline ? <h2>{props.headline}</h2> : <h1>Kunden</h1>
        }
        { !props.noSearch &&
          <div className="flex align-items-center">
            <Help>
              <h2>Suchfunktionen im Überblick</h2>
              <div>Einfach tippen und ein paar Sekunden warten. Dann werden automatisch die passenden Ergebnisse geladen.</div>
              <h3>Sonderfunktionen:</h3>
              <ul>
                <li><strong>@</strong>: Ort - Verwende dieses Präfix, um nach einem Ort des Unternehmens zu suchen</li>
              </ul>
            </Help>
            <InputB
              className='flex-grow'
              returnVal={async (val) => {
                setStatus(Status.loading)
                await Items.setNeedle(val)
                setGlobNeedle(val)
                setStatus(Status.standard)
              }}
              rows={1}
              placeholder='Tippen um zu suchen oder neu anzulegen ...'
              value={Needle}
              clearButton={true}
              sendButton="Suchen"
              delay={-1}
            />
          </div>
        }
        {
          Needle !== '' &&
          <Button
            variant="outlined"
            sx={{marginTop: 2}}
            onClick={async () => {
              if (status === Status.new) { return }
              setStatus(Status.new)
              const item = new ItemCustomerDTO({})
              await item.infoAbsorber(Needle)
              // await item.setName(Needle)
              if (props.onSelect) {
                props.onSelect(item.id, item)
              } else {
                setStatus(Status.loading)
                await Items.getFromServer()
              }
              setStatus(Status.standard)
            }}
          >
            {
              status === Status.new ? <>
                <Spinner mini />&nbsp;<span className='name'>Kunde {Needle.split(/\n/)[0]} wird angelegt</span>
              </> : <>
                <Plus /><span className='name'>Den Kunden {Needle.split(/\n/)[0]} anlegen</span>
              </>
            }
            
          </Button>
        }
      </div> : null
    }
    <div
      ref={infinitScroll.getRef()}
      className={`CustomerList ${props.standalone ? 'scrollContent' : ''}`}
    >
      {
        props.standalone &&
        <Tabs
          value={customerListTabs.findIndex(i => i.key === tabKey)}
          onChange={(event, newValue) => {
            setTabKey(customerListTabs[newValue].key)
          }}
          sx={{backgroundColor: '#fff'}}
        >
          {
          customerListTabs.map((i, index) => {
              return <Tab
                key={`Tab-${index}`}
                label={i.name}
              />
            })
          }
        </Tabs>
      }
      {
        status === Status.loading &&
        <Spinner />
      }
      {
        tabKey === 'all' &&
        Items.getItems().map((i, index) => {
          const markStale = OptionArrayHasValue(props.options, 'customerMarkStale', 'yes')
          const staleClass = markStale && index > 0 ? 'inactive' : ''
          return <Customer
              key={`CustomerListItem-${i.id}`}
              className={`hover ${props.selected === i.id ? 'mark' : ''} ${staleClass}`.trim()}
              item={i}
              onClick={props.onSelect}
              onTrash={props.onTrash || props.standalone ? async () => {
                if (!window.confirm(`${i.name} wirklich löschen?`)) { return }
                setStatus(Status.loading)
                await Items.trashItem(i.id)
                setStatus(Status.standard)
              } : undefined}
              onRemove={props.onRemove ? () => {
                if (props.onRemove) {
                  props.onRemove(i.id)
                }
              } : undefined}
              options={props.options}
            />
        })
      }
      {
        tabKey === 'fkts' &&
        <UserCustomerMatrix />
      }
      {
        status === Status.loadMore &&
        <div className='textCenter'>
          <Spinner mini={true} />
          <div>Lade weitere Elemente</div>
        </div>
      }
      {
        Items.getItems().length === 0 && status !== Status.loading &&
        <Alert severity="info">Keine Kunden gefunden</Alert>
      }
    </div>
  </PlaningToolRoot>
}
